// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewActionSection_container__PPaFW","voteSection":"ReviewActionSection_voteSection__h6vCI","likeButton":"ReviewActionSection_likeButton__ge7eX"};